<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Consultar
        </v-btn>
      </v-col>
    </v-row>

    <!-- show-expand
        single-expand -->
    <br />

    <v-data-table
      show-expand
      single-expand
      :expanded.sync="expanded"
      :search="search"
      :headers="headers"
      :items="pricingsList"
      item-key="tarificador.id"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <template v-slot:expanded-item="{ item }">
        <td :colspan="10">
          <v-container>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Extensión
                    </th>
                    <th class="text-left">
                      Cantidad de llamadas
                    </th>
                    <th class="text-left">
                      T. Duración
                    </th>
                    <th class="text-left">
                      T. Hablado
                    </th>
                    <th class="text-left">
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, key) in item.resumen" :key="key">
                    <td>{{ i.ext }}</td>
                    <td>{{ decimalFormatter(i.TCalls) || "0" }}</td>
                    <td>{{ decimalFormatter(i.mnDuracion) || "0" }}</td>
                    <td>{{ decimalFormatter(i.mnHablado) || "0" }}</td>
                    <td>{{ currencyFormatter(i.mnValor) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- <v-row>
              <v-col cols="12" md="2" v-if="item.resumen.ext != undefined">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.resumen.ext
                    }}</v-list-item-title>
                    <v-list-item-subtitle>Extensión</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      decimalFormatter(item.resumen.TCalls)
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >Tiempo de llamada</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      decimalFormatter(item.resumen.mnDuracion)
                    }}</v-list-item-title>
                    <v-list-item-subtitle>M. hablado</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      decimalFormatter(item.resumen.mnHablado)
                    }}</v-list-item-title>
                    <v-list-item-subtitle> M. Duración</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      currencyFormatter(item.resumen.mnValor)
                    }}</v-list-item-title>
                    <v-list-item-subtitle>M. Valor</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row> -->
          </v-container>
        </td>
      </template>

      <!-- <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover>
      </template> -->
    </v-data-table>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></newForm>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import newForm from "./newForm.vue";
// import btnupdate from '@/components/auth/user/btnupdate.vue';

export default {
  name: "PricingReport",

  components: {
    newForm,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    expanded: [],
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    pricingsList: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "tarificador.name",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Prefijo",
        align: "left",
        value: "tarificador.prefix",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Longitud",
        value: "tarificador.longitud",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Valor",
        value: "tarificador.value",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Tipo",
        value: "tarificador.bill_type",
        class: "primary--text",
        width: "20%",
      },
      // {
      //   text: "Acciones",
      //   value: "action",
      //   class: "primary--text",
      //   width: "15%",
      //   align: "left",
      //   sortable: false,
      // },
    ],
    payload: {
      dateStart: new Date().toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      type: 1,
      tarificador_id: null,
    },
  }),

  // watch: {
  //   options: {
  //     handler() {
  //       this.getPrincings();
  //     },
  //     deep: true,
  //   },
  // },

  created() {
    this.getPrincings();
  },

  methods: {
    currencyFormatter(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        minimumFractionDigits: 2,
        currency: "USD",
        // currencyDisplay: "symbol",
      });
      return formatter.format(value);
    },

    decimalFormatter(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 0,
        // currencyDisplay: "symbol",
      });
      return formatter.format(value);
    },

    openFormDialog() {
      this.isOpenForm = true;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    async handleDelete(event) {
      // const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/clients/tarificador/${event.id}`)
            .then((res) => {
              const index = this.pricingsList.findIndex(
                (el) => el.id === res.data.Troncal
              );
              this.pricingsList.splice(index, 1);

              this.$snotify.success("Troncal eliminado", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar el troncal.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      this.pricingsList = data;
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    async getPrincings(payload = this.payload) {
      this.isLoading = true;

      // const { page, itemsPerPage } = this.options;
      // params: { page, itemPerPage: itemsPerPage },

      await PbxHttpClient.post(`/report-tarificador`, payload)
        .then((res) => {
          this.pricingsList = res.data;
          console.log(this.pricingsList);
          // this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
